import React                from "react";

// Components
import TitleList            from "./Title/TitleList";
import FeeList              from "./Fee/FeeList";
import BalanceList          from "./Balance/BalanceList";
import ButtonList           from "Components/App/Core/Button/ButtonList";
import PageList             from "Components/App/Core/Page/PageList";

// Dashboard
import Router               from "Dashboard/Components/Route/Router";
import AdminRoute           from "Dashboard/Components/Route/AdminRoute";
import Navigation           from "Dashboard/Components/Navigation/Navigation";
import NavigationList       from "Dashboard/Components/Navigation/NavigationList";
import NavigationItem       from "Dashboard/Components/Navigation/NavigationItem";



/**
 * The Administration Container
 * @returns {React.ReactElement}
 */
function AdministrationContainer() {
    return <>
        <Navigation icon="administration" message="ADMINISTRATION_NAME">
            <NavigationList>
                <NavigationItem
                    message="TITLES_NAME"
                    url="TITLES"
                    icon="title"
                />
                <NavigationItem
                    message="FEES_NAME"
                    url="FEES"
                    icon="fee"
                />
                <NavigationItem
                    message="BALANCES_NAME"
                    url="BALANCES"
                    icon="balance"
                />
            </NavigationList>
            <NavigationList>
                <NavigationItem
                    message="BUTTONS_NAME"
                    url="BUTTONS"
                    icon="button"
                />
                <NavigationItem
                    message="PAGES_NAME"
                    url="PAGES"
                    icon="page"
                />
            </NavigationList>
        </Navigation>

        <Router type="ADMIN">
            <AdminRoute url="TITLES"   component={TitleList}   />
            <AdminRoute url="FEES"     component={FeeList}     />
            <AdminRoute url="BALANCES" component={BalanceList} />

            <AdminRoute url="BUTTONS"  component={ButtonList}  />
            <AdminRoute url="PAGES"    component={PageList}    />
        </Router>
    </>;
}

export default AdministrationContainer;
